import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[idpFlyoutPosition]',
  standalone: true
})
export class FlyoutPositionDirective implements OnInit {
  @Input() headerSelector = '.header__top';
  @Input() alignToSelector = 'idp-search-wrapper';
  @Input() centerPage = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (this.centerPage) return;
    this.setPosition();
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth > 991) {
      this.setPosition();
    }
  }

  private setPosition(): void {
    this.setParentClasses();
    this.setTopPosition();
    this.setRightPosition();
  }

  private setParentClasses(): void {
    const parentElement = this.el.nativeElement.parentElement;
    if (parentElement) {
      this.renderer.addClass(parentElement, '!justify-end');
      this.renderer.addClass(parentElement, '!items-start');
    }
  }

  private setTopPosition(): void {
    const headerElement = document.querySelector(this.headerSelector);
    if (!headerElement) return;

    const alertAdvisories = document.querySelector(
      '.idp-alert-advisories-container'
    );
    const alertHeight = alertAdvisories
      ? (alertAdvisories as HTMLElement).offsetHeight
      : 0;
    this.renderer.setStyle(
      this.el.nativeElement,
      'top',
      `${78 + alertHeight}px`
    );
  }

  private setRightPosition(): void {
    let alignElement = document.querySelector(this.alignToSelector);

    // Fallback to idp-notification if the primary align element is not found or hidden
    if (!alignElement || (alignElement as HTMLElement).offsetParent === null) {
      alignElement = document.querySelector('idp-notification');
    }

    if (!alignElement) return;

    const alignRect = alignElement.getBoundingClientRect();
    this.renderer.setStyle(
      this.el.nativeElement,
      'right',
      `${window.innerWidth - alignRect.right - 44}px`
    );
  }
}
